import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import AccountAPI from '../../api/account';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false
  },
};

export const getters = {
  getSubaccounts($state) {    
    return $state.records;
  },
  getSubaccount: $state => id => {
    return $state.records.find(record => record.id === Number(id));
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getMeta(_state) {
    return _state.meta;
  },
};

export const actions = {
  get: async function getSubaccounts({ commit }, params = {}) {
    commit(types.SET_SUBACCOUNTS_UI_FLAG, { isFetching: true });
    try {
      const response = await AccountAPI.subaccounts(params);
      const records = (response.data.payload || []).sort((a, b) =>
        a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' })
      );
      commit(types.SET_SUBACCOUNTS, records);
      if(response.data.meta){
        commit(types.SET_META, response.data.meta);
      }
    } catch (error) {
      console.log(error);
    } finally {
      commit(types.SET_SUBACCOUNTS_UI_FLAG, { isFetching: false });
    }
  },
  search: async ({ commit }, params) => {    
    commit(types.SET_SUBACCOUNTS_UI_FLAG, { isFetching: true });
    try {
      const { page, sortAttr, search } = params;
      const response = await AccountAPI.searchSubaccounts(page, sortAttr, search);

      commit(types.SET_SUBACCOUNTS, response.data.payload);
      commit(types.SET_META, response.data.meta);
    } catch (error) {
      console.log(error);
      // Ignore error
    } finally {
      commit(types.SET_SUBACCOUNTS_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_SUBACCOUNTS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_SUBACCOUNTS]: MutationHelpers.set,
  [types.SET_META](_state, data) {
    _state.meta = data;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
